import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps, useCallback, useState, useEffect } from 'react';
import 'leaflet/dist/leaflet.css';
import { useEventCallback } from '../../hooks/useEventCallback';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { classes } from '../../utils/utils';
import styles from './BasemapMap.module.css';
import { MapController, MapHandle } from './MapController/MapController';
export type BasemapMapProps = PropsWithoutChildren<Omit<ComponentProps<'div'>, 'ref'>> & {
  refHandle?: (handle: MapHandle | null) => void;
  onMapMove?: (handle: MapHandle) => void;
};
export const BasemapMap: FunctionComponent<BasemapMapProps> = React.memo(props => {
  const $ = _c(6);
  const {
    refHandle,
    onMapMove,
    className,
    ...remainingProps
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  const [mapController, setMapController] = useState(null);
  const handleMapMove = useEventCallback(handle => {
    onMapMove?.(handle);
  });
  let t0;
  if ($[0] !== handleMapMove) {
    t0 = element => {
      setMapController(oldMapController => {
        oldMapController?.destroy();
        if (element) {
          const controller = new MapController({
            element,
            onMapMove: handleMapMove
          });
          controller.init();
          return controller;
        }
        return null;
      });
    };
    $[0] = handleMapMove;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const containerRef = t0;
  useEffect(() => {
    refHandle?.(mapController?.getHandle() ?? null);
    return () => {
      refHandle?.(null);
    };
  }, [refHandle, mapController]);
  const t1 = classes(className, styles.container);
  let t2;
  if ($[2] !== containerRef || $[3] !== remainingProps || $[4] !== t1) {
    t2 = <div ref={containerRef} className={t1} {...remainingProps} />;
    $[2] = containerRef;
    $[3] = remainingProps;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
});